<app-header [user]="user" (logout)="authService.logout()"></app-header>
<app-banner [user]="user"></app-banner>
<router-outlet></router-outlet>
<app-footer *ngIf="user"></app-footer>
<app-toast-messages></app-toast-messages>
